import {RelativeFilterResponseBody, ReorderRelativeFiltersRequestBody} from '@dms/api/core';

export function buildReorderRelativeFiltersBody(
  orderedPresets: RelativeFilterResponseBody[]
): ReorderRelativeFiltersRequestBody {
  return {
    items: orderedPresets.flatMap((preset, index) =>
      preset.default ? [] : [{id: preset.id, position: index + 1}]
    ),
  };
}
